export * from './delete-zahlungseingang.component';
export * from './delete-zahlungseingang.component.module';